<template>
  <div>
    <component :is="questionStore.step"></component>
  </div>
</template>

<script setup>
import questions from './json/questions.json';
import results from './json/results.json';
import {onMounted} from "vue";
import {useQuestionStore} from "@/stores/question.js";

const questionStore = useQuestionStore();

onMounted(() => {
  questionStore.questions = questions;
  questionStore.results = results;
});

</script>

<style scoped>
/*
 @import "../../../web/themes/custom/ucam/assets/css/ucam.style.css";
*/
</style>

